import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers/rootReducer";
import rootSaga from "../sagas/rootSaga";

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();
let middleware: any[];

console.log('[Store] NODE_ENV:', process.env.NODE_ENV);
console.log('[Store] STAGE:', process.env.STAGE);

// Enable Redux logger for beta and gamma, disable for prod
const enableLogger = process.env.STAGE === 'beta' || process.env.STAGE === 'gamma';
console.log('[Store] Redux logger enabled:', enableLogger);

if (enableLogger) {
  // Add logger in beta/gamma for debugging
  const reduxLogger = require("redux-logger");
  const loggerMiddleware = reduxLogger.createLogger({ collapsed: true });
  middleware = [sagaMiddleware, loggerMiddleware];
} else {
  // Disable logger in prod for performance
  middleware = [sagaMiddleware];
}

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

// Run the saga
sagaMiddleware.run(rootSaga);

export default store;
